module.exports = __webpack_public_path__ + "static/media/magnifying-glass-solid-full.447cfdc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/magnifying-glass-solid-full.svg
// module id = 258
// module chunks = 0